
import React from 'react'
import styled from 'styled-components'
import { ReactComponent as FileIcon } from "../../Assets/icons/fileIcon.svg"
const FileAttachmentItem = ({ file }) => {

    const returnMb = (size) => {
        if (!size) {
            return
        }

        let mb = (size / 1000000)
        let kb = (size / 1000)

        if (mb.toFixed(2) <= 1.00) {
            return `${kb.toFixed(2)} Kb`
        } else {
            return `${mb.toFixed(2)} Mb`
        }

    }
    return (
        <Container>
            <FileIcon />
            <InfoWrapper>
                <h1>{file.name}</h1>
                <p>{returnMb(file.size)}</p>
            </InfoWrapper>
        </Container>
    )
}

export default FileAttachmentItem

const Container = styled.div`
display:flex;
background:${({ theme }) => theme.menu.background};
padding:15px;
border-radius:16px;
min-width:100px;
max-width:400px;
align-items:center;
gap:10px;
svg{
    color: ${({ theme }) => theme.menu.primaryTextColor};
    min-width:40px;
    max-width:40px;
    max-height:40px;
}

`
const InfoWrapper = styled.div`
display:flex;
flex-direction:column;
width:100%;
overflow:hidden;
h1 {
    white-space:pre;
    text-overflow:ellipsis;
    overflow:hidden;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
  p {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
  }
`